import { Toolbar, Button, makeStyles } from "@fluentui/react-components";
import { useEffect } from "react";

const useStyles = makeStyles({
    toolbar: {
        
    }
});

export default function VendorsPage()
{
    const styles = useStyles();

    useEffect(
        () => {
            document.title = "Vendors - Omnivend";
        },
        []
    );

    return <>
        <Toolbar className={styles.toolbar}>
            <Button appearance="subtle">Test</Button>
        </Toolbar>
    </>;
}